var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.cookie)?_c('cookie-law',{attrs:{"buttonText":"Accepter","message":"Ce site Web utilise des cookies pour vous garantir la meilleure expérience sur notre site Web.","theme":"royal"},on:{"accept":function($event){return _vm.ThankYouMethod()}}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }